// extracted by mini-css-extract-plugin
export default {"tips":"RenderColumn_tips__5qXi1"};